import { Skeleton } from '@/components/ui/skeleton';

/**
 * Loading skeleton displayed while lazy-loaded route components are being fetched.
 * Mimics the typical page layout with header and content areas.
 */
export function PageSkeleton() {
  return (
    <div className="flex flex-col h-full p-6 space-y-6">
      {/* Header skeleton */}
      <div className="flex items-center justify-between">
        <div className="space-y-2">
          <Skeleton className="h-8 w-48" />
          <Skeleton className="h-4 w-32" />
        </div>
        <Skeleton className="h-10 w-24" />
      </div>

      {/* Content skeleton */}
      <div className="flex-1 space-y-4">
        <Skeleton className="h-12 w-full" />
        <Skeleton className="h-64 w-full" />
        <Skeleton className="h-32 w-full" />
      </div>
    </div>
  );
}
